import * as Yup from "yup";
import { DOMAIN_NAME_REGEX } from "../constants";

export const step0 = Yup.object({
  email: Yup.string()
    .email("Must be a valid email")
    .required("Email is Required")
    .when("email_exists", {
      is: true,
      then: () => Yup.string().max(0, "Email already exists."),
    }),
  business_name: Yup.string()
    .required("Business Name is Required")
    .when("business_exists", {
      is: true,
      then: () => Yup.string().max(0, "Business name is already taken."),
    }),
  domain_name: Yup.string()
    .matches(DOMAIN_NAME_REGEX, "Must be a valid Domain")
    .required("Domain is Required")
    .when("domain_exists", {
      is: true,
      then: () => Yup.string().max(0, "Domain name is already taken."),
    }),
  first_name: Yup.string().required("First Name is Required"),
  last_name: Yup.string().required("Last Name is Required"),
});
export const step1 = Yup.object({
  website_name: Yup.string().required("Website is required"),
  website_logo: Yup.string().required("Logo is required"),
  website_hero_img: Yup.string().required("Hero image is required"),
  website_palette: Yup.array()
    .min(1, "Palette is required for the website theme")
    .required("Palette is required for the website theme")
    .test(
      "has-primary-and-secondary",
      "At least one primary and one secondary color are required",
      (palette) => {
        if (!palette || !Array.isArray(palette)) return false;
        const hasPrimary = palette.some((color) => color.status === "primary");
        const hasSecondary = palette.some(
          (color) => color.status === "secondary"
        );
        return hasPrimary && hasSecondary;
      }
    ),
  domain: Yup.string().required("Domain is required"),
});
export const step2 = Yup.object({
  country: Yup.number().required("Country is Required"),
  state: Yup.number().required("State is Required"),
  city: Yup.string().required("City is Required"),
  street: Yup.string().required("street# is Required"),
  zip: Yup.string().required("Zip code is Required"),
  phone: Yup.string()
    .min(7, "Must be a valid Phone Number")
    .required("Phone number is Required"),
});
export const step3 = Yup.object({
  insta_url: Yup.string().required("Instagram Link is Required"),
  x_url: Yup.string().required("X Link is Required"),
  fb_url: Yup.string().required("Facebook Link is Required"),
});
export const step4 = Yup.object({
  acc_holder_name: Yup.string().required("Account Holder is Required"),
  account_number: Yup.string()
    .required("Account Number is Required")
    .when("account_number_exist", {
      is: true,
      then: () => Yup.string().max(0, "Account Number Already Exist"),
    }),
  branch_name: Yup.string().required("Branch Name is Required"),
  bank_id: Yup.number().required("Bank is Required"),
  cr: Yup.string().required("CR is Required"),
});

export const onBoardingValidationSchema = (activeTab) => {
  const schemas = [step0, step1, step2, step3, step4];

  return schemas[activeTab];
};
